<mat-form-field *ngIf="isDisabled" class="w-full {{ cssClass }}" [appearance]="appearance">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    matInput
    type="text"
    disabled
    [value]="
      (selectedLabels?.[0] || '') + (selectedLabels?.length > 1 ? ' + ' + (selectedLabels.length - 1) + ' more' : '')
    " />
</mat-form-field>

<mat-form-field
  [class.hidden]="isDisabled"
  class="w-full {{ cssClass }}"
  [appearance]="appearance"
  subscriptSizing="dynamic">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <button
    type="button"
    matSuffix
    *ngIf="allowClear && !select.empty"
    mat-icon-button
    aria-label="Clear"
    (click)="clear($event)">
    <mat-icon>close</mat-icon>
  </button>
  <mat-select
    panelClass="searchable-select-panel pt-0 {{ panelClass }}"
    #select
    [compareWith]="compareWith"
    [multiple]="multiple"
    (openedChange)="openedChange($event)"
    [formControl]="control"
    (focus)="focus.next($event)"
    (blur)="blur.next($event)"
    [panelWidth]="null">
    <mat-select-trigger *ngIf="multiple">
      {{ selectedLabels?.[0] || "" }}
      <span class="font-semibold text-xs text-gray-400" *ngIf="selectedLabels?.length > 1">
        + {{ selectedLabels.length - 1 }} more
      </span>
    </mat-select-trigger>

    <div class="flex flex-col">
      <mat-form-field
        class="search-input bg-white w-full z-10 sticky top-0 {{ cssClass }}"
        [class.hidden]="hideSearch"
        [appearance]="appearance"
        subscriptSizing="dynamic">
        <input
          #searchControl
          matInput
          autocomplete="off"
          placeholder="{{ placeholder }}"
          (keydown.space)="onSpaceKeydown($event)"
          [(ngModel)]="searchText"
          (ngModelChange)="searchTextChanged()" />
        <button
          type="button"
          mat-icon-button
          matSuffix
          *ngIf="includeAddButton"
          [disabled]="!canAdd"
          (click)="addItem(searchText, $event)">
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
      </mat-form-field>

      <div class="flex-1">
        <ng-container>
          <mat-optgroup *ngIf="noMatches" disabled label="{{ noMatchMessage }}"></mat-optgroup>
        </ng-container>

        <mat-option
          *ngFor="let item of filteredOptions"
          class="flex {{ (includeRemoveButton && item.canRemove) || item.clipboardDetails ? 'pr-0' : '' }}"
          [value]="item.value"
          [hidden]="item.forceOpenOption"
          (onSelectionChange)="onSelectionChange($event, select)">
          <div class="flex w-full items-center">
            <mat-icon class="mr-1" *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span class="flex-1">{{ item.label }}</span>
            <button
              type="button"
              mat-icon-button
              matSuffix
              class="flex"
              *ngIf="item.clipboardDetails"
              [disabled]="clipboardCopied === item.clipboardDetails"
              (click)="copyToClipboard(item, $event)">
              <mat-icon
                class="mx-0"
                [svgIcon]="
                  clipboardCopied === item.clipboardDetails
                    ? 'heroicons_outline:check'
                    : 'heroicons_outline:clipboard-document'
                "></mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              matSuffix
              class="flex"
              *ngIf="includeRemoveButton && item.canRemove"
              (click)="removeItem(item, $event)">
              <mat-icon class="mr-0" svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
          </div>
        </mat-option>
      </div>
    </div>
  </mat-select>
</mat-form-field>